import numeral from "numeral";
export const getValueFromMetric = (metric) => {
  if (!metric) {
    return 0;
  }
  switch (metric.type) {
    case "meter":
      return metric.metric.rate.one_minute;
    case "gauge":
      return metric.metric.value;
    case "counter":
      return metric.metric.count;
    default:
      return 0;
  }
};
export const formatCount = (count) => numeral(Math.round(count)).format("0,0");
const inputsMeticNames = [
  "incomingMessages",
  "emptyMessages",
  "open_connections",
  "total_connections",
  "written_bytes_1sec",
  "written_bytes_total",
  "read_bytes_1sec",
  "read_bytes_total"
];
export const prefixMetric = (input, metric) => `${input.type}.${input.id}.${metric}`;
export const getMetricNamesForInput = (input) => inputsMeticNames.map((metric) => prefixMetric(input, metric));
export const calculateInputMetrics = (input, metrics) => {
  const result = {};
  const metricNames = getMetricNamesForInput(input);
  metricNames.forEach((metricName) => {
    result[metricName] = Object.keys(metrics).reduce((previous, nodeId) => {
      if (!metrics[nodeId][metricName]) {
        return previous;
      }
      const value = getValueFromMetric(metrics[nodeId][metricName]);
      if (value !== void 0) {
        return isNaN(previous) ? value : previous + value;
      }
      return previous;
    }, NaN);
  });
  return result;
};
export const calculateInputMetricsByNode = (input, metrics) => {
  const metricNames = getMetricNamesForInput(input);
  const result = {};
  for (const [nodeId, nodeMetrics] of Object.entries(metrics)) {
    const perNode = {};
    for (const metricName of metricNames) {
      const rawMetric = nodeMetrics[metricName];
      if (!rawMetric) {
        continue;
      }
      const value = getValueFromMetric(rawMetric);
      if (typeof value === "number" && !isNaN(value)) {
        perNode[metricName] = value;
      }
    }
    if (Object.keys(perNode).length > 0) {
      result[nodeId] = perNode;
    }
  }
  return result;
};
export const getInputConnectionMetrics = (input, calculatedMetrics) => {
  const resolve = (name) => calculatedMetrics[prefixMetric(input, name)];
  return {
    openConnections: resolve("open_connections"),
    totalConnections: resolve("total_connections"),
    emptyMessages: resolve("emptyMessages"),
    writtenBytes1Sec: resolve("written_bytes_1sec"),
    writtenBytesTotal: resolve("written_bytes_total"),
    readBytes1Sec: resolve("read_bytes_1sec"),
    readBytesTotal: resolve("read_bytes_total")
  };
};
